import { render } from "./EditTextbook.vue?vue&type=template&id=4f9fd208&scoped=true"
import script from "./EditTextbook.vue?vue&type=script&lang=js"
export * from "./EditTextbook.vue?vue&type=script&lang=js"

import "./EditTextbook.vue?vue&type=style&index=0&id=4f9fd208&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9fd208"]])

export default __exports__